import React from "react";
import ReactDOM from "react-dom";

import "./lightbox.scss";

export class Lightbox extends React.Component {
  static defaultProps = {
    className: "",
    onClose: () => {},
  };

  constructor(props) {
    super(props);

    this.container = document.createElement("div");
    document.body.appendChild(this.container);
  }

  componentWillUnmount() {
    document.body.removeChild(this.container);
  }

  render() {
    const { className } = this.props;
    return ReactDOM.createPortal(
      <div
        className={`overlay flex flex-column items-center fixed z2 top-0 left-0 right-0 bottom-0 p2 m-auto ${className}`}
      >
        <div
          className="overlay__close self-start h0 bold absolute top-0"
          style={{ cursor: `pointer` }}
          onClick={this.props.onClose}
        >
          <svg role="img" aria-label="Close lightbox">
            <use xlinkHref="#close-icon"></use>
          </svg>
        </div>
        {this.props.children}
      </div>,
      this.container
    );
  }
}
